import { faUser } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import styled from 'styled-components';

export function Avatar({
  src,
  size = 20,
  variant = 'circle',
}: {
  src?: string | null;
  size?: number;
  variant?: 'circle' | 'square';
}) {
  const [hasError, setHasError] = useState(!src);

  return (
    <AvatarContainer $size={size} $variant={variant}>
      {src && !hasError ? (
        <AvatarImage
          src={src}
          $variant={variant}
          onError={() => setHasError(true)}
        />
      ) : (
        <AvatarIcon icon={faUser} $size={size} />
      )}
    </AvatarContainer>
  );
}

const radius = (variant: 'circle' | 'square') =>
  variant === 'circle' ? '50%' : '5px';

const AvatarContainer = styled.div<{
  $size: number;
  $variant: 'circle' | 'square';
}>`
  align-items: center;
  background-color: var(--grey-400);
  border-radius: ${(props) => radius(props.$variant)};
  display: flex;
  flex-shrink: 0;
  height: ${(props) => props.$size}px;
  justify-content: center;
  overflow: hidden;
  width: ${(props) => props.$size}px;
`;

const AvatarImage = styled.img<{ $variant: 'circle' | 'square' }>`
  border-radius: ${(props) => radius(props.$variant)};
  height: 100%;
  object-fit: cover;
  width: 100%;
`;

const AvatarIcon = styled(FontAwesomeIcon)<{ $size: number }>`
  color: var(--white);
  font-size: ${(props) => props.$size / 2}px;
`;
